import angular from 'angular';

export const repeatEnd = () => ({
    restrict: 'A',
    link(scope, element, attrs) {
        if (scope.$last) {
            scope.$eval(attrs.repeatEnd);
        }
    },
});

angular
    .module('TALENYA-FE')
    .directive('repeatEnd', repeatEnd);
